export const regexValidationPrice = /^([0-9]{1,}(\.[0-9]{1,}){0,1})*$/;
